import React from "react";
import { WEEKDAYS } from "./utils";

const Calendar = ({
  calMonth,
  goToMonth,
  calendarDays,
  selectedDay,
  setSelectedDay,
  followUpBadges,
}) => {
  return (
    <div className="card">
      <div className="cal-nav">
        <button className="arrow" onClick={() => goToMonth(-1)}>‹</button>
        <div className="month">
          {calMonth.toLocaleDateString("en-US", { month: "long", year: "numeric" })}
        </div>
        <button className="arrow" onClick={() => goToMonth(1)}>›</button>
      </div>
      <div className="cal-grid">
        <div className="cal-dow">
          {WEEKDAYS.map((d, i) => (
            <div key={i}>{d}</div>
          ))}
        </div>
        <div className="cal-days">
          {calendarDays.map((d) => {
            const badgeCount = !d.dim ? followUpBadges[d.n] : undefined;
            return (
              <button
                key={d.key}
                className={`day-cell${d.dim ? " dim" : ""}${d.today ? " today" : ""}${
                  selectedDay === d.key ? " selected" : ""
                }`}
                disabled={d.dim}
                onClick={() => setSelectedDay((prev) => (prev === d.key ? null : d.key))}
              >
                {d.n}
                {!!badgeCount && <span className="followup-badge">{badgeCount}</span>}
              </button>
            );
          })}
        </div>
      </div>
      <div className="cal-legend">
        <span>
          <span className="leg-dot" style={{ background: "var(--teal)" }}></span> Today
        </span>
        <span>
          <span className="leg-dot" style={{ background: "var(--orange)" }}></span> Follow-ups scheduled
        </span>
      </div>
    </div>
  );
};

export default Calendar;
